
export enum ErrorStatusEnum {
  error='error',
  failed='failed',
  http='http',
  canceled='canceled',
}

export enum ErrorCodeEnum {
  authentication='AuthenticationException',
  critical='CRITICAL_EXCEPTION',
  message='MessageException',
  validation='VALIDATION',
}

export interface ValidationErrors {
  [key: string]: string[];
}

// This value is only available in local and QA environments.
// We will display it if API-V2 return it.
interface Debug {
  ex_message: string,
}
export class ValidationErrorResponse extends Error {
  constructor(
    public readonly error: {
      error_code: ErrorCodeEnum.validation,
      error_message: string,
      errors: ValidationErrors,
    },
    public readonly debug?: Debug,
  ) {
    super(error.error_message);
    Object.setPrototypeOf(this, ValidationErrorResponse.prototype);
  }
}
export class ErrorResponse extends Error {
  constructor(
    public readonly error: {
      error_code: ErrorCodeEnum.critical | ErrorCodeEnum.message,
      error_message: string,
    },
    public readonly debug?: Debug,
  ) {
    super(error.error_message);
    Object.setPrototypeOf(this, ErrorResponse.prototype);
  }
}

export type ApiResponseErrors = (
  ErrorResponse |
  ValidationErrorResponse |
  null
)

export interface ApiResponse<Response = unknown> {
  data: Response;
}
